import { Extension } from '@tiptap/core'

import { Color } from '@tiptap/extension-color'
import Highlight from '@tiptap/extension-highlight'
import TextAlign from '@tiptap/extension-text-align'
import Underline from '@tiptap/extension-underline'
import TextStyle from '@tiptap/extension-text-style'

import { CustomTextStyle } from './marks/text-style.js'
import { A } from './tags/a.js'
import { CustomParagraph } from './tags/p.js'
import { Center } from './tags/center.js'
import { Iframe } from './tags/iframe.js'
import { Div } from './tags/div.js'
import { Heading } from './tags/heading.js'
import { Img } from './tags/img.js'
import { Span } from './tags/span.js'
import { TableExtension } from './tags/table.js'

export const HTMLSpec = Extension.create({
  name: 'HTMLSpec',

  addExtensions() {
    const extensions = []

    // tiptap extensions
    extensions.push(Color)
    extensions.push(Highlight.configure({ multicolor: true }))
    extensions.push(TextAlign.configure({ types: ['heading', 'paragraph', 'image'] }))
    extensions.push(Underline)
    extensions.push(CustomParagraph)

    // textStyle base mark (needed for "Color" extension)
    extensions.push(TextStyle)
    extensions.push(CustomTextStyle)

    // generic tags
    extensions.push(A.configure({ openOnClick: false, autolink: false }))
    extensions.push(Center)
    extensions.push(Iframe)
    extensions.push(Div)
    extensions.push(Heading)
    extensions.push(Img.configure({ inline: true }))
    extensions.push(Span)
    extensions.push(TableExtension)

    return extensions
  },
})
